import { Icon } from './Icon';

export function VerseList({ surah, audio }) {
  return (
    <div className="verse-list">
      {surah.ayahs.map((ayah) => {
        const active = audio.activeAyah === ayah.numberInSurah;
        return (
          <article className={`verse-card ${active ? 'is-active' : ''}`} id={`vers-${ayah.numberInSurah}`} key={ayah.numberInSurah}>
            <div className="verse-toolbar">
              <span className="ayah-number" aria-label={`Vers ${ayah.numberInSurah}`}>{ayah.numberInSurah}</span>
              <button
                className="ayah-play"
                type="button"
                onClick={() => audio.playAyah(ayah.numberInSurah)}
                aria-label={active && audio.isPlaying ? `Pauzeer vers ${ayah.numberInSurah}` : `Luister naar vers ${ayah.numberInSurah}`}
              >
                <Icon name={active && audio.isPlaying ? 'pause' : 'play'} />
                <span>{active && audio.isPlaying ? 'Pauzeer' : 'Luister'}</span>
              </button>
            </div>
            <p className="ayah-arabic" dir="rtl" lang="ar">{ayah.arabic}</p>
            <p className="ayah-transliteration">{ayah.transliteration}</p>
            <p className="ayah-translation">{ayah.translation}</p>
          </article>
        );
      })}
    </div>
  );
}
